import { useEffect, useState, useCallback } from "react"
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { useNavigate } from "react-router-dom";
import { CHAVE_TOKEN, real, dataBR, hojeISO } from "../../../utils/formata";

export default function RelatorioDiario() {
    const [data, setData] = useState(hojeISO());
    const [rel, setRel] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const { consultarRelatorioDiario } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        consultarRelatorioDiario(data)
            .then((r) => setRel(r))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [data, consultarRelatorioDiario, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar();
    }, [carregar, navigate]);

    function textoWhatsApp() {
        if (!rel) return "";
        const r = rel.resumo;
        let txt = `📊 *HELP EMPRESARIAL — Fechamento ${dataBR(rel.data)}*\n\n`;
        txt += `🟢 Entradas: ${real(r.totalEntradas)}\n`;
        txt += `🔴 Saídas: ${real(r.totalSaidas)}\n`;
        txt += `💰 Saldo do dia: ${real(r.saldoDia)}\n`;
        txt += `🏦 Saldo acumulado: ${real(r.saldoAcumulado)}\n\n`;
        if (rel.parcelasRecebidas.length > 0) {
            txt += `✅ *Parcelas recebidas (${rel.parcelasRecebidas.length}):*\n`;
            rel.parcelasRecebidas.forEach((p) => {
                txt += `• ${p.Emprestimo?.Empresa?.nomeFantasia || p.Emprestimo?.Empresa?.razaoSocial} — parcela ${p.numero} — ${real(p.valorPago)}\n`;
            });
            txt += `\n`;
        }
        if (rel.novosEmprestimos.length > 0) {
            txt += `📝 *Novos contratos (${rel.novosEmprestimos.length}):*\n`;
            rel.novosEmprestimos.forEach((e) => {
                txt += `• ${e.Empresa?.nomeFantasia || e.Empresa?.razaoSocial} — ${real(e.valorPrincipal)} em ${e.numParcelas}x\n`;
            });
            txt += `\n`;
        }
        if (rel.naoPagasQueVenciam.length > 0) {
            txt += `⚠️ *Venciam hoje e NÃO foram pagas (${rel.naoPagasQueVenciam.length}):*\n`;
            rel.naoPagasQueVenciam.forEach((p) => {
                txt += `• ${p.Emprestimo?.Empresa?.nomeFantasia || p.Emprestimo?.Empresa?.razaoSocial} — parcela ${p.numero} — ${real(p.valor)}\n`;
            });
        }
        return txt;
    }

    return (
        <div className="pagina">
            <div className="nao-imprimir cabecalho-pagina" style={{alignItems: "flex-end"}}>
                <h2 className="he-titulo">Relatório <span className="he-dourado">do Dia</span></h2>
                <div className="cabecalho-pagina" style={{flex: "0 1 auto", justifyContent: "flex-end", alignItems: "flex-end", gap: 8}}>
                    <div className="form-mobile">
                        <label className="form-label he-dourado" style={{fontSize: "0.8em"}}>Data</label>
                        <input className="form-control" type="date" value={data} onChange={(e) => setData(e.target.value)}/>
                    </div>
                    <div className="acoes-linha uma-coluna" style={{alignItems: "flex-end"}}>
                        <button className="btn btn-outline-he" onClick={() => window.print()}><i className="bi bi-printer"></i> Imprimir / PDF</button>
                        <a className="btn btn-success" href={`https://wa.me/?text=${encodeURIComponent(textoWhatsApp())}`} target="_blank" rel="noreferrer"><i className="bi bi-whatsapp"></i> Enviar no WhatsApp</a>
                    </div>
                </div>
            </div>

            {carregando || !rel ? <div style={{textAlign: "center", padding: "2em"}}><span className="spinner-border" style={{color: "#d4af37"}}></span></div> : <>

            <div className="he-card" style={{margin: "1em 0", textAlign: "center"}}>
                <h4 style={{fontWeight: 700, fontSize: "clamp(1.05rem, 4.6vw, 1.5rem)", lineHeight: 1.3}}>HELP <span className="he-dourado">EMPRESARIAL</span> — Fechamento de {dataBR(rel.data)}</h4>
                <div className="cards-estatistica" style={{marginTop: 12}}>
                    <div className="card-estat" style={{"--cor-acento": "#2ecc71"}}><div className="estat-rotulo">ENTRADAS</div><div className="estat-numero" style={{color: "#2ecc71"}}>{real(rel.resumo.totalEntradas)}</div></div>
                    <div className="card-estat" style={{"--cor-acento": "#ff6b5b"}}><div className="estat-rotulo">SAÍDAS</div><div className="estat-numero" style={{color: "#ff6b5b"}}>{real(rel.resumo.totalSaidas)}</div></div>
                    <div className="card-estat" style={{"--cor-acento": rel.resumo.saldoDia >= 0 ? "#2ecc71" : "#ff6b5b"}}><div className="estat-rotulo">SALDO DO DIA</div><div className="estat-numero" style={{color: rel.resumo.saldoDia >= 0 ? "#2ecc71" : "#ff6b5b"}}>{real(rel.resumo.saldoDia)}</div></div>
                    <div className="card-estat"><div className="estat-rotulo">SALDO ACUMULADO</div><div className="estat-numero" style={{color: "#d4af37"}}>{real(rel.resumo.saldoAcumulado)}</div></div>
                </div>
            </div>

            <div className="he-card sem-rolagem" style={{marginBottom: "1em"}}>
                <h5 className="he-titulo he-dourado"><i className="bi bi-arrow-left-right"></i> Movimentações ({rel.movimentacoes.length})</h5>
                {rel.movimentacoes.length === 0 ? <p style={{color: "#9aa5b5"}}>Nenhuma movimentação no dia.</p> :
                    <table className="table table-striped tabela-responsiva" style={{fontSize: "0.9em"}}>
                        <thead><tr><th></th><th>Descrição</th><th>Empresa</th><th>Valor</th></tr></thead>
                        <tbody>
                            {rel.movimentacoes.map((m) => (
                                <tr key={m.id}>
                                    <td className="esconder-mobile"><i className={m.tipo === "entrada" ? "bi bi-arrow-down-circle-fill" : "bi bi-arrow-up-circle-fill"} style={{color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}></i></td>
                                    <td className="principal" data-rotulo="Descrição">{m.descricao || m.categoria}</td>
                                    <td data-rotulo="Empresa">{m.Empresa ? (m.Empresa.nomeFantasia || m.Empresa.razaoSocial) : "—"}</td>
                                    <td className="destaque" data-rotulo="Valor" style={{fontWeight: 600, color: m.tipo === "entrada" ? "#2ecc71" : "#ff6b5b"}}>{m.tipo === "entrada" ? "+" : "-"}{real(m.valor)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
            </div>

            {rel.novosEmprestimos.length > 0 &&
                <div className="he-card sem-rolagem" style={{marginBottom: "1em"}}>
                    <h5 className="he-titulo he-dourado"><i className="bi bi-file-earmark-plus"></i> Novos contratos</h5>
                    <table className="table table-striped tabela-responsiva" style={{fontSize: "0.9em"}}>
                        <thead><tr><th>Empresa</th><th>Valor</th><th>Parcelas</th><th>Taxa</th></tr></thead>
                        <tbody>
                            {rel.novosEmprestimos.map((e) => (
                                <tr key={e.id}><td className="principal" data-rotulo="Empresa">{e.Empresa?.nomeFantasia || e.Empresa?.razaoSocial}</td><td className="destaque" data-rotulo="Valor">{real(e.valorPrincipal)}</td><td data-rotulo="Parcelas">{e.numParcelas}x {real(e.valorParcela)}</td><td data-rotulo="Taxa">{Number(e.taxaJuros)}% a.m.</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }

            {rel.naoPagasQueVenciam.length > 0 &&
                <div className="he-card sem-rolagem" style={{marginBottom: "1em", border: "1px solid #e74c3c"}}>
                    <h5 className="he-titulo" style={{color: "#ff6b5b"}}><i className="bi bi-exclamation-triangle"></i> Venciam no dia e não foram pagas</h5>
                    <table className="table table-striped tabela-responsiva" style={{fontSize: "0.9em"}}>
                        <thead><tr><th>Empresa</th><th>Parcela</th><th>Valor</th></tr></thead>
                        <tbody>
                            {rel.naoPagasQueVenciam.map((p) => (
                                <tr key={p.id}><td className="principal" data-rotulo="Empresa">{p.Emprestimo?.Empresa?.nomeFantasia || p.Emprestimo?.Empresa?.razaoSocial}</td><td data-rotulo="Parcela">{p.numero}</td><td className="destaque" data-rotulo="Valor" style={{color: "#ff6b5b", fontWeight: 600}}>{real(p.valor)}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
            </>}
        </div>
    )
}
